import axiosClient from './axiosClient';

export interface UserDto {
  id: number;
  email: string;
  username: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserInput {
  email: string;
  username: string;
  password: string;
  isActive?: boolean;
  role?: 'user' | 'admin';
  nextcloudUsername?: string;
  nextcloudPassword?: string;
  nextcloudFolder?: string;
  nifColumn?: string;
  linkExpirationDays?: number;
  nameColumn?: string;
  emailColumn?: string;
  phoneColumn?: string;
}

export interface UpdateUserInput {
  email?: string;
  username?: string;
  password?: string;
  isActive?: boolean;
  role?: 'user' | 'admin';
  nextcloudUsername?: string;
  nextcloudPassword?: string;
  nextcloudFolder?: string;
  nifColumn?: string;
  linkExpirationDays?: number;
  nameColumn?: string;
  emailColumn?: string;
  phoneColumn?: string;
}

export interface ListUsersResponse { data: UserDto[]; total: number; page: number; limit: number }

export async function listUsers(params?: { page?: number; limit?: number; q?: string }): Promise<ListUsersResponse> {
  const { data } = await axiosClient.get('/users', { params });
  return data;
}

export async function getUser(id: number): Promise<UserDto> {
  const { data } = await axiosClient.get(`/users/${id}`);
  return data;
}

export async function createUser(input: CreateUserInput): Promise<UserDto> {
  const { data } = await axiosClient.post('/users', input);
  return data;
}

export async function updateUser(id: number, input: UpdateUserInput): Promise<UserDto> {
  const { data } = await axiosClient.post(`/users/${id}/update`, input);
  return data;
}

export async function deleteUser(id: number): Promise<void> {
  await axiosClient.delete(`/users/${id}`);
}


